var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140-140v-51.539l40-40V-140h-40Zm160 0v-211.539l40-40V-140h-40Zm160 0v-251.539l40 41V-140h-40Zm160 0v-210.539l40-40V-140h-40Zm160 0v-371.539l40-40V-140h-40ZM140-375.461v-56.078l260-260 160 160 260-260v56.078l-260 260-160-160-260 260Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.29e2808ef82c29d18fc6eb275be41fd3.svg";
export { ForwardRef as ReactComponent };